import styled from '@emotion/styled'
import { ButtonStrip } from 'view/components/buttons'

export const ClientLogStreamScreenContent = styled.div`
  padding: 20px 32px;
  display: flex;
  flex-direction: column;
`
export const ItalicMessage = styled.i`
  padding-bottom: 20px;
`

export const LogLevelComponentContainer = styled.div`
  display: flex;
  padding-bottom: 10px;
  flex-direction: row;
  span {
    padding-right: 10px;
    min-width: 150px;
  }
  ${ButtonStrip} button {
    width: 50px;
  }
`
